// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".axq-empty {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n.axq-empty-img {\n  margin-top: 29.733vw;\n  width: 32vw;\n  height: 32vw;\n}\n.axq-empty-text {\n  font-size: 4vw;\n  color: #666;\n  line-height: 6.667vw;\n}\n.axq-empty-text:first-of-type {\n  margin-top: 5.333vw;\n}\n", ""]);
// Exports
module.exports = exports;
